// Shared helpers for the Floating Officer Dock

// Map URL paths -> context_type + (id-extractor function)
export const PATH_TO_CONTEXT = [
  { match: /\/political-intel/, type: "political", getId: () => localStorage.getItem("proxima_active_profile_id") || "" },
  { match: /\/brief/, type: "brief", getId: () => "" },
  { match: /\/alert/, type: "alert", getId: () => "" },
  { match: /\/crisis/, type: "crisis_simulator", getId: () => "" },
  { match: /\/dashboard/, type: "dashboard", getId: () => "" },
  { match: /\/sentiment/, type: "sentiment", getId: () => "" },
  { match: /\/demo/, type: "general", getId: () => "" },
];

export function detectContext(pathname) {
  for (const rule of PATH_TO_CONTEXT) {
    if (rule.match.test(pathname)) {
      return { type: rule.type, id: rule.getId() };
    }
  }
  return { type: "general", id: "" };
}

export const isAuthenticated = () => {
  try {
    // Real session OR demo session — both show the dock (demo gets a conversion CTA)
    if (localStorage.getItem("proxima_session_token") || localStorage.getItem("proxima_token")) return true;
    const demoSession = localStorage.getItem("demo_session");
    if (demoSession) {
      try {
        const parsed = JSON.parse(demoSession);
        return !!(parsed && (parsed.id || parsed.session_id));
      } catch (e) { return false; }
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const isFullAccount = () => {
  try {
    return !!(localStorage.getItem("proxima_session_token") || localStorage.getItem("proxima_token"));
  } catch (e) { return false; }
};

export const HIDDEN_PATHS = ["/login", "/register", "/auth", "/trust", "/privacy", "/terms", "/cookie-policy", "/data-retention", "/ai-policy"];

export const copyText = (text) => {
  try { navigator.clipboard.writeText(text); } catch (e) { /* clipboard unavailable */ }
};

export const downloadImage = (b64, mime, name) => {
  const a = document.createElement("a");
  a.href = `data:${mime};base64,${b64}`;
  a.download = `${(name || "proxima-image").replace(/[^a-z0-9-]/gi, "-")}-${Date.now()}.png`;
  document.body.appendChild(a); a.click(); a.remove();
};

// Global event used by Navbar / Demo banners to open the dock from anywhere
export const OPEN_OFFICERS_EVENT = "proxima:open-officers";
export const openOfficerDock = () => window.dispatchEvent(new CustomEvent(OPEN_OFFICERS_EVENT));
